export default defineNuxtRouteMiddleware((_to, _from) => {
  // Guest middleware: Allows access without authentication.
  // We keep it for explicitness on public routes.
  return
})

